export enum USER_ROLE_KEYS {
  Customer = 'Customer',
  Supplier = 'Supplier',
  Internal_User = 'Internal_User',
  RFQManager = 'RFQManager',
  Admin = 'Admin',
  Unregistered_Supplier_Admin = 'Unregistered_Supplier_Admin',
  Auditor = 'Auditor',
  Business_Development = 'Business_Development',
  Legal = 'Legal',
  Sales_Solution = 'Sales_Solution',
  Procurement = 'Procurement',
  Operations = 'Operations',
  Finance = 'Finance',
  Operation_Super_Admin = 'Operation_Super_Admin',
  Logistics = 'Logistics',
  System_User = 'System_User',
  Regional_Head = 'Regional_Head',
  Procurement_Head = 'Procurement_Head',
  Operation_Head = 'Operation_Head',
  Logistics_Head = 'Logistics_Head',
  Logistics_Team = 'Logistics_Team',
  Finance_Head = 'Finance_Head',
  COO = 'COO',
}

export enum USER_TYPES {
  Customer = 'Customer',
  Supplier = 'Supplier',
  Internal_User = 'Internal_User',
  RFQManager = 'RFQManager',
  Admin = 'Admin',
  Unregistered_Supplier_Admin = 'Unregistered_Supplier_Admin',
  Auditor = 'Auditor',
  Business_Development = 'KAM',
  Legal = 'Legal',
  Sales_Solution = 'Sales_Solution',
  Procurement = 'Purchasing Admin',
  Operations = 'Ops Admin',
  Finance = 'Finance',
  Operation_Super_Admin = 'SuperAdmin',
  Logistics = 'Logistics',
  System_User = 'System_User',
  Regional_Head = 'Regional_Head',
  Procurement_Head = 'Procurement_Head',
  Operation_Head = 'Operation_Head',
  Logistics_Head = 'Logistics_Head',
  Logistics_Team = 'Logistics_Team',
  Finance_Head = 'Finance_Head',
  COO = 'COO',
}
export enum USER_ROLE_KEYS_LABELS {
  Customer = 'Customer',
  Supplier = 'Supplier',
  Internal_User = 'Internal User',
  RFQManager = 'RFQ Manager',
  Admin = 'Admin',
  Unregistered_Supplier_Admin = 'Unregistered Supplier Admin',
  Auditor = 'Auditor',
  Business_Development = 'Business Development',
  Legal = 'Legal',
  Sales_Solution = 'Sales Solution',
  Procurement = 'Procurement',
  Operations = 'Operations',
  Finance = 'Finance',
  Operation_Super_Admin = 'Operation Super Admin',
  Logistics = 'Logistics',
  System_User = 'System User',
  Regional_Head = 'Regional Head',
  Procurement_Head = 'Procurement Head',
  Operation_Head = 'Operation Head',
  Logistics_Head = 'Logistics Head',
  Logistics_Team = 'Logistics Team',
  Finance_Head = 'Finance Head',
  COO = 'COO',
}

export enum RFQStatusLabel {
  DRAFT = 'Draft',
  QUOTE_IN_PROGRESS = 'Quote in Progress',
  RFQ_RECEIVED = 'RFQ Received',
  NOT_PUBLISHED = 'Not Published',
  PUBLISHED_TO_SHOP = 'Published to Shop',
  NEW_PROSPECT = 'New Prospect',
  DEADLINE_CLOSED = 'Deadline Closed',
  PROSPECT_CLOSED = 'Prospect Closed',
  QUOTE_IN_REVIEW = 'Quote in Review',
  QUOTE_READY = 'Quote Ready',
  QUOTE_SENT = 'Quote Sent',
  QUOTE_ACCEPTED = 'Quote Accepted',
  QUOTE_RETURNED = 'Quote Returned',
  RFQ_DISCONTINUED = 'RFQ Discontinued',
  RFQ_RETURNED = 'RFQ Returned',
  PO_RAISED = 'P.O. Raised',
  PO_RECEIVED = 'P.O. Received',
  PO_ACCEPTED = 'P.O. Accepted',
  PO_RETURNED = 'P.O. Returned',
  PO_SENT = 'P.O. Sent',
  QUOTE_SELECTED = 'Quote Selected',
  QUOTE_NOT_SELECTED = 'Quote not Selected',
  QUOTE_RECEIVED = 'Quote  Received',
  ARCHIVE = 'Archive',

  CUSTOMER_PO_RECEIVED = 'Customer P.O. Received',
  CUSTOMER_PO_ACCEPTED = 'Customer P.O. Accepted',
  CUSTOMER_PO_RETURNED = 'Customer P.O. Returned',
  SUPPLIER_PO_ACCEPTED = 'Supplier P.O. Accepted',
  SUPPLIER_PO_RETURNED = 'Supplier P.O. Returned',

  SO_REVISED = 'SO Revised',
  SO_UPLOADED = 'SO Uploaded',
  PR_UPLOADED = 'PR Uploaded',
  PR_AWAITING = 'PR Awaiting',
  NOT_FEASIBLE = 'Not Feasible',
}

export enum RFQStatus {
  DRAFT = 'DRAFT',
  QUOTE_IN_PROGRESS = 'QUOTE_IN_PROGRESS',
  RFQ_RECEIVED = 'RFQ_RECEIVED',
  NOT_PUBLISHED = 'NOT_PUBLISHED',
  RFQ_RETURNED = 'RFQ_RETURNED',
  PUBLISHED_TO_SHOP = 'PUBLISHED_TO_SHOP',
  NEW_PROSPECT = 'NEW_PROSPECT',
  DEADLINE_CLOSED = 'DEADLINE_CLOSED',
  PROSPECT_CLOSED = 'PROSPECT_CLOSED',
  QUOTE_IN_REVIEW = 'QUOTE_IN_REVIEW',
  QUOTE_READY = 'QUOTE_READY',
  QUOTE_SENT = 'QUOTE_SENT',
  QUOTE_ACCEPTED = 'QUOTE_ACCEPTED',
  QUOTE_RETURNED = 'QUOTE_RETURNED',
  RFQ_DISCONTINUED = 'RFQ_DISCONTINUED',
  PO_RAISED = 'PO_RAISED',
  PO_RECEIVED = 'PO_RECEIVED',
  PO_ACCEPTED = 'PO_ACCEPTED',
  PO_RETURNED = 'PO_RETURNED',
  PO_SENT = 'PO_SENT',
  QUOTE_SELECTED = 'QUOTE_SELECTED',
  QUOTE_NOT_SELECTED = 'QUOTE_NOT_SELECTED',
  QUOTE_RECEIVED = 'QUOTE_RECEIVED',
  ARCHIVE = 'ARCHIVE',
  ADMIN_RFQ_ACCEPTED = 'ADMIN_RFQ_ACCEPTED',
  ADMIN_RFQ_RETURNED = 'ADMIN_RFQ_RETURNED',

  CUSTOMER_PO_RECEIVED = 'CUSTOMER_PO_RECEIVED',
  CUSTOMER_PO_ACCEPTED = 'CUSTOMER_PO_ACCEPTED',
  CUSTOMER_PO_RETURNED = 'CUSTOMER_PO_RETURNED',
  SUPPLIER_PO_ACCEPTED = 'SUPPLIER_PO_ACCEPTED',
  SUPPLIER_PO_RETURNED = 'SUPPLIER_PO_RETURNED',

  SO_REVISED = 'SO_REVISED',
  SO_UPLOADED = 'SO_UPLOADED',
  PR_UPLOADED = 'PR_UPLOADED',
  PR_AWAITING = 'PR_AWAITING',
  NOT_FEASIBLE = 'NOT_FEASIBLE',
}

export enum FileType {
  RFQ = 'RFQ',
  Drawing = 'Drawing',
  Drawing_2D = 'Drawing_2D',
  Drawing_3D = 'Drawing_3D',
  PO = 'PO',
  Quote = 'Quote',
  Quote_Tooling = 'Quote_Tooling',
  Quote_Capex = 'Quote_Capex',
  Quote_Component = 'Quote_Component',
  Certificate = 'Certificate',
  Additional = 'Additional',
  PR = 'PR',
  SO = 'SO',
  Video = 'Video',
  TNC = 'TNC',
  Chat_File = 'Chat_File',
  Invoice_GON = 'Invoice_GON',
  Invoice = 'Invoice',
  GON = 'GON',
  MRO = 'MRO',
  PDC = 'PDC',
}

export enum FileTypeLabel {
  RFQ = 'RFQ',
  Drawing = 'Drawing',
  Drawing_2D = 'Drawing 2D',
  Drawing_3D = 'Drawing 3D',
  PO = 'PO',
  Quote = 'Quote',
  Quote_Tooling = 'Quote Tooling',
  Quote_Capex = 'Quote Capex',
  Quote_Component = 'Quote Component',
  Quote_Logistics = 'Quote Logistics',
  Quote_RawMaterial = 'Quote Raw Material',
  Quote_InDirectMRO = 'Quote InDirectMRO',
  Quote_Others = 'Quote Others',
  Quote_CommercialRefrigeration = 'Quote Commercial Refrigeration',

  Additional = 'Additional',
  NDA = 'NDA',
  Video = 'Video',
  TNC = 'T&C',
  Invoice_GON = 'Invoice GON',
  Invoice = 'Invoice',
  GON = 'GON',
  MRO = 'MRO',
  PDC = 'PDC',
}

export enum UserType {
  Customer = 'Customer',
  Supplier = 'Supplier',
  Admin = 'Admin',
  Auditor = 'Auditor',
}

export enum UserTypeUrlParam {
  customer = 'customer',
  supplier = 'supplier',
  internal = 'internal',
  shop = 'shop',
}

export enum FileStatus {
  Live = 'Live',
  Archive = 'Archive',
}
export enum AdminStatus {
  RETURNED = 'RETURNED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  ACTION_PLAN_RECEIVED = 'ACTION_PLAN_RECEIVED',
  ASSESSMENT_RECEIVED = 'ASSESSMENT_RECEIVED',
  AWAITED = 'AWAITED',
  BLACKLISTED = 'BLACKLISTED',
  WHITELISTED = 'WHITELISTED',
}
export enum AdminStatusLabel {
  RETURNED = 'Returned',
  APPROVED = 'Approved',
  ACTION_PLAN_RECEIVED = 'Action Plan Received',
  ASSESSMENT_RECEIVED = 'Assessment Received',
  AWAITED = 'Awaited',
  PENDING = 'Pending',
  BLACKLISTED = 'Blacklisted',
  WHITELISTED = 'Whitelisted',
}
export enum SupplierStatus {
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  ACTION_PLAN_SHARED = 'ACTION_PLAN_SHARED',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  AUDITOR_ASSIGNED = 'AUDITOR_ASSIGNED',
  PROFILE_VERIFIED = 'PROFILE_VERIFIED',
  PENDING = 'PENDING',
}
export enum SupplierStatusLabel {
  ACTION_REQUIRED = 'Action Required',
  ACTION_PLAN_SHARED = 'Action Plan Shared',
  AWAITING_APPROVAL = 'Awaiting Approval',
  AUDITOR_ASSIGNED = 'Auditor Assigned',
  PROFILE_VERIFIED = 'Profile Verified',
}

export enum TemplateTypeLabel {
  Component = 'Component',
  Tooling = 'Tooling',
  CapEx = 'Capital Equipment',
  Others = 'Others',
  InDirectMRO = 'Indirect MRO',
  RawMaterial = 'Raw Material',
  CommercialRefrigeration = 'Commercial Refrigeration',
  Logistics = 'Logistics',
  Dealership ='Dealership',
  Refrigeration ='Refrigeration',
  Paint = 'Paint'
}

export enum TemplateType {
  Component = 'Component',
  Tooling = 'Tooling',
  CapEx = 'CapEx',
  Others = 'Others',
  InDirectMRO = 'InDirectMRO',
  RawMaterial = 'RawMaterial',
  CommercialRefrigeration = 'CommercialRefrigeration',
  Logistics = 'Logistics',
  Dealership ='Dealership',
  Refrigeration ='Refrigeration',
  Paint = 'Paint'
}

export enum EDPStatus {
  EDP_RECEIVED = 'EDP_RECEIVED',
  EDP_APPROVED = 'EDP_APPROVED',
  EDP_SENT_FOR_APPROVAL = 'EDP_SENT_FOR_APPROVAL',
  EDP_RETURN = 'EDP_RETURN',
  EDP_PENDING = 'EDP_PENDING',
  EDP_DRAFT = 'EDP_DRAFT',
  EDP_CLOSED = 'EDP_CLOSED',
  EDP_ACCEPTED = 'EDP_ACCEPTED',
  EDP_REVISED = 'EDP_REVISED',
  EDP_IN_PROGRESS = 'IN_PROGRESS',
  EDP_COMPLETED = 'EDP_COMPLETED',
  SENT_TO_CUSTOMER = 'SENT_TO_CUSTOMER',
  SENT_TO_Business_Development = 'SENT_TO_Business_Development',
}
export enum EDPStatusLabel {
  EDP_RECEIVED = 'EDP Received',
  EDP_APPROVED = 'EDP Approved',
  EDP_SENT_FOR_APPROVAL = 'EDP Sent For Approval',
  EDP_RETURN = 'EDP Returned',
  EDP_PENDING = 'EDP Pending',
  EDP_DRAFT = 'EDP Draft',
  EDP_CLOSED = 'EDP Closed',
  EDP_ACCEPTED = 'EDP Accepted',
  EDP_REVISED = 'EDP Received(Revised)',
  IN_PROGRESS = 'In Progress',
  EDP_COMPLETED = 'EDP Completed',
  SENT_TO_CUSTOMER = 'EDP Sent to Customer',
  SENT_TO_Business_Development = 'EDP Sent to KAM',
}
export enum OrderStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'EDP_COMPLETED',
  ARCHIVE = 'ARCHIVE',
  PENDING = 'EDP_PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  READY = 'READY',
}
export enum OrderStatusLabel {
  ACTIVE = 'Active',
  EDP_COMPLETED = 'Completed',
  ARCHIVE = 'Archive',
  EDP_PENDING = 'Pending',
  IN_PROGRESS = 'In Progress',
  READY = 'Ready',
}
export enum AuditorStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  DELAYED = 'DELAYED',
  COMPLETED = 'COMPLETED',
  NOT_INITIATED = 'NOT_INITIATED',
  AWAITED = 'AWAITED',
  RECEIVED = 'RECEIVED',
  RETURNED_TO_AUDITOR = 'RETURNED_TO_AUDITOR',
  ASSESSMENT_RETURNED = 'ASSESSMENT_RETURNED',
}
export enum AuditorStatusLabel {
  NEW = 'New',
  IN_PROGRESS = 'In Progress',
  DELAYED = 'Delayed',
  COMPLETED = 'Completed',
  NOT_INITIATED = 'Not Initiated',
  AWAITED = 'Awaited',
  RECEIVED = 'Received',
  RETURNED_TO_AUDITOR = 'Returned to Auditor',
  ASSESSMENT_RETURNED = 'Assessment Returned',
}

export enum MilestoneStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  NEW = 'NEW',
}
export enum MilestoneStatusLabel {
  IN_PROGRESS = 'In Progress',
  PENDING = 'Pending',
  COMPLETED = 'Completed',
  NEW = 'Ned',
}
export enum NDAStatusLabel {
  PENDING = 'Pending',
  IN_REVIEW = 'Received',
  RETURNED = 'Returned',
  APPROVED = 'Approved',
  LEGAL_VERIFIED = 'Legally Verified',
}

export enum NDAStatusLabelSupplier {
  PENDING = 'Pending',
  IN_REVIEW = 'In Review',
  RETURNED = 'Returned',
  APPROVED = 'Approved',
}
export enum NDAStatus {
  PENDING = 'PENDING',
  IN_REVIEW = 'IN_REVIEW',
  RETURNED = 'RETURNED',
  APPROVED = 'APPROVED',
  LEGAL_VERIFIED = 'LEGAL_VERIFIED',
}
export enum MilestoneState {
  SKIP = 'SKIP',
  ACTIVE = 'ACTIVE',
}
export enum MilestoneStateLabel {
  SKIP = 'Skip',
  ACTIVE = 'Active',
}
export enum EntityType {
  OMS = 'OMS',
  MILESTONE = 'MILESTONE',
  EDP = 'EDP',
  SUBMILESTONE = 'SUBMILESTONE',
  RFQ_CUSTOMER = 'RFQ_CUSTOMER'
}

export enum PermissionKeys {
  SUPPLIER_NDA_LEGAL = 'supplier_nda_legal',
  SUPPLIER_NDA_APPROVAL = 'supplier_nda_approval',
}
export enum KYCStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  RECEIVED = 'RECEIVED',
  RETURNED = 'RETURNED',
  IN_REVIEW = 'IN_REVIEW',
  PENDING = 'PENDING',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  PA_APPROVED = 'PA_APPROVED',
  PA_RETURNED = 'PA_RETURNED',
  PA_AAF = 'PA_AAF',
  PA_AF = 'PA_AF',
  PA_RF = 'PA_RF',
  FA_APPROVED = 'FA_APPROVED',
  FA_RETURNED = 'FA_RETURNED',
  BD_APPROVED = 'BD_APPROVED',
  BD_RETURNED = 'BD_RETURNED',
  BD_AAF = 'BD_AAF',
  BD_AF = 'BD_AF',
  BD_RF = 'BD_RF',
}

export enum KYCStatusLabel {
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  RECEIVED = 'Received',
  IN_REVIEW = 'In Review',
  RETURNED = 'Returned',
  PENDING = 'Pending',
  AWAITING_APPROVAL = 'Awating Approval',
  PA_APPROVED = 'PA Approved',
  PA_RETURNED = 'PA Returned',
  PA_AAF = 'Awating Approval Finance',
  PA_AF = 'PA_AF',
  PA_RF = 'PA RF',
  FA_APPROVED = 'Finance Approved',
  FA_RETURNED = 'Finance Returned',
  BD_APPROVED = 'APPROVED',
  BD_RETURNED = 'RETURNED',
  BD_AAF = 'Awaiting Approval from Finance',
  BD_AF = 'KYC Approved from Finance',
  BD_RF = 'KYC Returned from finance',
}
export enum patternForm {
   emailPattern = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$',
   mobilePattern = '^[1-9][0-9]{9}$',
   pincode = '^\d{4}$',
}
export enum DocusignEvents {
  Signing_Complete = 'signing_complete',
  Viewing_Complete = 'viewing_complete',
  Decline = 'decline',
}
export interface ChatMetaData {
  receivers: USER_ROLE_KEYS[];
  service: EntityType;
  canAddComment: boolean;
  entityType: EntityType;
  hasNewComment: boolean;
}